const LoadingScreen = (function ()
{
    let show = function() {
        $('#loading-screen').show();
        $('body').addClass('lock-body');
    }

    let hide = function(delay = 100) {
        setTimeout(function() {
            $('#loading-screen').hide();
            $('body').removeClass('lock-body');
        }, delay);

    }

    return {
        show: show,
        hide: hide,
    };
})();

window.LoadingScreen = LoadingScreen;
